export default {"src":"/_next/static/media/sauna.1645f6d4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};